module.exports = __webpack_public_path__ + "img/Tache.81276d3a.svg";